import { render, staticRenderFns } from "./material-db-list.view.vue?vue&type=template&id=3e69b79c&"
import script from "./material-db-list.view.vue?vue&type=script&lang=ts&"
export * from "./material-db-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports